export const setRoute = () => {
    if (!process.env.API_HOST_URL) {
        throw new Error('API_HOST_URL envrionment variable is not set.');
    }

    return process.env.API_HOST_URL;
};

export default setRoute();
